import React, { JSX } from 'react';
import { ICWorkspaceGuideLink } from './ic-guide-link';
import { Button, Icon, Text, Callout } from '../providers/harmony-scope/lazy-enablers';
import { useMEMTranslation } from '../utils/text-utils';

export interface ISimpleTooltipProps {
  children: string | React.ReactNode;
  isLargeTooltip?: boolean;
  heading: string;
}

export const SimpleTooltip = (props: ISimpleTooltipProps) => {
  const { children, isLargeTooltip = false, heading } = props;
  const { t } = useMEMTranslation();

  // Compose a descriptive aria-label for the info button using the heading
  let infoButtonAriaLabel = heading ? `${heading}` : '';
  // If heading matches the translated moduleRefreshTooltipHeader, use moduleRefreshLabel for aria-label
  const moduleRefreshTooltipHeader = t('moduleRefreshTooltipHeader');
  if (heading === moduleRefreshTooltipHeader) {
    infoButtonAriaLabel = t('moduleRefreshLabel');
  }
  // Append ariaOpenTooltip translation
  const ariaOpenTooltip = t('ariaOpenTooltip');
  const fullAriaLabel = infoButtonAriaLabel ? `${infoButtonAriaLabel} ${ariaOpenTooltip}` : ariaOpenTooltip;

  return !isLargeTooltip ? (
    <Callout heading={heading} style={{ display: 'inline-block' }} fixed-placement>
      <Button slot="anchor" appearance="link" label={fullAriaLabel} aria-label={fullAriaLabel}>
        <Icon name="info" role="button" />
      </Button>
      {children}
    </Callout>
  ) : (
    <Callout heading={heading} style={{ '--width': '700px', display: 'inline-block' }} fixed-placement>
      <Button slot="anchor" appearance="link" label={fullAriaLabel} aria-label={fullAriaLabel}>
        <Icon name="info" role="button" />
      </Button>
      {children}
    </Callout>
  );
};

type TTooltipSegment = string | JSX.Element;

export const SimpleTooltipContent = (texts: TTooltipSegment[]) =>
  texts &&
  texts.map((item, index) => (
    <React.Fragment key={`simpletooltip-key-${index}`}>
      <Text>{item}</Text>
      <div style={{ height: '10px' }} />
    </React.Fragment>
  ));

export const SimpleTooltipContentWithICGuideLink = (texts: string[]) => (
  <>
    {SimpleTooltipContent(texts)}
    <ICWorkspaceGuideLink />
  </>
);
